module.exports = __webpack_public_path__ + "static/img/acornIcon@2x.db4c8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/acornIcon@2x.png
// module id = qGSP
// module chunks = 0